const Scales = () => {
  return (
    <span className="svg-icon">
      <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.25 5.2475C8.8875 5.0225 9.3975 4.5125 9.6225 3.875H12L9.75 9.125C9.75 10.37 10.9275 11.375 12.375 11.375C13.8225 11.375 15 10.37 15 9.125L12.75 3.875H14.25V2.375H9.6225C9.315 1.4975 8.4825 0.875 7.5 0.875C6.5175 0.875 5.685 1.4975 5.3775 2.375H0.75V3.875H2.25L0 9.125C0 10.37 1.1775 11.375 2.625 11.375C4.0725 11.375 5.25 10.37 5.25 9.125L3 3.875H5.3775C5.6025 4.5125 6.1125 5.0225 6.75 5.2475V13.625H0V15.125H15V13.625H8.25V5.2475ZM13.7775 9.125H10.9725L12.375 5.855L13.7775 9.125ZM4.0275 9.125H1.2225L2.625 5.855L4.0275 9.125ZM7.5 3.875C7.0875 3.875 6.75 3.5375 6.75 3.125C6.75 2.7125 7.0875 2.375 7.5 2.375C7.9125 2.375 8.25 2.7125 8.25 3.125C8.25 3.5375 7.9125 3.875 7.5 3.875Z" fill="white"/>
      </svg>
    </span>
  )
}

export default Scales